module.exports = __webpack_public_path__ + "img/collection-memoireRingsRedgold.b9b1d1e.webp";